const headerModule = {
	namespaced: true,
	state: {
		headerHeight: null,
		categoriesArray: [],
		categoriesPromise: undefined,
		loggedIn: false,
		cartNum: 0,
		hasEmail: false,
		userStatePromise: undefined,
		cartData: undefined,
	},
	getters: {},
	mutations: {
		setHeaderHeight(state, headerHeight) {
			state.headerHeight = headerHeight;
		},
		setCategories(state, categoriesData) {
			state.categoriesArray = categoriesData;
		},
		setCategoriesPromise(state, categoriesPromise) {
			state.categoriesPromise = categoriesPromise;
		},
		setLoggedIn(state, loggedIn) {
			state.loggedIn = loggedIn;
		},
		setCartNum(state, cartNum) {
			state.cartNum = cartNum;
		},
		setUserStatePromise(state, userStatePromise) {
			state.userStatePromise = userStatePromise;
		},
		setCartData(state, cartData){
			state.cartData = cartData;
		},
		setHasEmail(state, val) {
			state.hasEmail = val;
		},
	},
	actions: {
		getCategories({ state, commit }, axios) {
			if (state.categoriesArray.length) {
				return state.categoriesArray;
			}
			if (state.categoriesPromise && state.categoriesPromise instanceof Promise) {
				return state.categoriesPromise;
			}
			const promise = axios.get("/api/categories").then((res) => {
				commit("setCategories", res.data);
				return res;
			});
			commit("setCategoriesPromise", promise);
			return promise;
		},
		clearCategories({ state, commit }) {
			commit("setCategories", []);
			commit("setCategoriesPromise", undefined);
		},
		getUserState({ state, commit, dispatch, rootState }, { axios, cartId }) {
			if (!cartId) {
				return;
			}
			if (state.userStatePromise && state.userStatePromise instanceof Promise) {
				return state.userStatePromise;
			}
			const promise = axios.post("/api/shopping_cart/num", { cart_id: cartId }).then((res) => {
				commit("setLoggedIn", res.data.login);
				commit("setCartNum", res.data.num);
				commit("setHasEmail", res.data.has_email);
				return res;
			});
			commit("setUserStatePromise", promise);
			return promise;
		},
		// 訪客透明登入後，強制重新取得登入狀態／購物車數（清掉快取的 promise 再抓一次）
		refreshUserState({ commit, dispatch }, { axios, cartId }) {
			commit("setUserStatePromise", undefined);
			return dispatch("getUserState", { axios, cartId });
		},
	},
	modules: {},
}

export default headerModule;